import { ReactElement, useState } from "react";
import { useDependency } from "../../../../contexts/DependencyContext";
import { useTimeMachine, useTimeMachineUpdate } from "../../../../contexts/TimeMachineContext";
import { DateService } from "../../../../services/types/DateService";
import { CalendarDate } from "../../../../services/datepicker/interfaces/calendar-date";
import { className } from "../../../../shared/helpers";
import Datepicker from "../../../../components/Shared/Datepicker"
import styles from "./TimeTravelControls.module.scss";

const TimeTravelControls = (): ReactElement =>
{
    const dateService = useDependency(DateService);
    const timeMachine = useTimeMachine();
    const timeMachineUpdate = useTimeMachineUpdate();
    const [controlsVisible, setControlsVisibility] = useState<boolean>(false);

    function setHours(hours: number): void
    {
        const newDate = dateService.addHours(timeMachine, hours);
        timeMachineUpdate(new Date(newDate));
    }

    function setDays(days: number): void
    {
        const newDate = dateService.addDays(timeMachine, days);
        timeMachineUpdate(new Date(newDate));
    }

    function goBackFromToday(days: number): void
    {
        const today = new Date();
        const newDate = dateService.addDays(today, days);

        if (timeMachine.toDateString() !== newDate.toDateString())
            timeMachineUpdate(new Date(newDate));
    }

    const pickDate = (date: CalendarDate) =>
    {
        const { day, month, year, hours, minutes, seconds } = date
        timeMachineUpdate(new Date(year, month, day, hours, minutes, seconds));
    }

    return (
        <>
            <div {...className(styles.timeTravelControls, { [styles.controlsHidden]: !controlsVisible })}>
                <div className={styles.actions}>
                    <button title="Go back 1 day" {...className(styles.btn, styles.action)} onClick={() => setDays(-1)}>
                        <i className="material-icons">chevron_left</i>
                        <i className="material-icons">chevron_left</i>
                    </button>

                    <button title="Go back 1 hour" {...className(styles.btn, styles.action)} onClick={() => setHours(-1)}>
                        <i className="material-icons">chevron_left</i>
                    </button>

                    <button title="Go forward 1 hour" {...className(styles.btn, styles.action)} onClick={() => setHours(1)}>
                        <i className="material-icons">chevron_right</i>
                    </button>

                    <button title="Go forward 1 day" {...className(styles.btn, styles.action)} onClick={() => setDays(1)}>
                        <i className="material-icons">chevron_right</i>
                        <i className="material-icons">chevron_right</i>
                    </button>

                    <button {...className(styles.btn, styles.oneWeek)} onClick={() => goBackFromToday(-7)}>
                        One week ago
                    </button>

                    <button {...className(styles.btn, styles.yesterday)} onClick={() => goBackFromToday(-1)}>
                        Yesterday
                    </button>
                </div>

                <Datepicker
                    title="Choose a date and a time"
                    customClassName={styles.datepicker}
                    currentDate={timeMachine}
                    pickDate={pickDate}
                />

                <button {...className(styles.btn, styles.inverted, styles.closeDesktop)} onClick={() => timeMachineUpdate(undefined!)}>
                    <i className="material-icons">close</i>
                    <span>Exit</span>
                </button>
            </div>

            <div className={styles.mobileActions}>
                <button {...className(styles.btn, styles.inverted, { [styles.rotated]: controlsVisible })} onClick={() => setControlsVisibility(!controlsVisible)}>
                    <i className="material-icons">expand_more</i>
                </button>

                <button
                    {...className(styles.btn, styles.inverted)}
                    onClick={() => timeMachineUpdate(undefined!)}
                >
                    <i className="material-icons">close</i>
                </button>
            </div>
        </>
    );
}

export default TimeTravelControls;